import React, { useEffect, useState } from 'react';
import styled from 'styled-components'
import {
    SuggestionHoverColor,
    SuggestionHoverColorActive,
    WerfenColor,
    White
} from '../../../Constants/ColorChart';
import { REQUEST_RESOURCES_ZIP_MUTATION } from './Queries/requestResourcesZipMutation';
import { useMutation } from '@apollo/client';
import FeatherIconWrapper from "../FeatherIconWrapper";
import CancelIcon from "../Cancel/Cancel";

/*
 *  @Description:   Stateless component that renders a Filter.
 */

const StyledButton = styled.button`
    direction: ltr;
	background-color: transparent;
    border: 1px solid ${ props => props.color ? props.color : props.invertColor ? White : WerfenColor };
    border-radius: 0;
    color: ${ props => props.color ? props.color : props.invertColor ? White: WerfenColor };
    font-size: 14px;
    padding: 5px 29px;
    text-decoration: none;
    box-sizing: border-box;
	white-space: nowrap
    position: relative;
    margin: 4px 4px 20px 0;
    font-family: Roboto,sans-serif;
    font-weight: 400;
    line-height: 24px;
    outline:none;

    &:hover{
        @media(hover:hover){
            color: ${ White };
            background-color: ${ SuggestionHoverColor };
            border-color: ${ SuggestionHoverColor };
        }
    }
    &.active{
            color: ${ props => props.invertColor ? WerfenColor : White };
    	background-color: ${ props => props.color ? props.color : props.invertColor ? White : WerfenColor };
        cursor: pointer;
        &:hover{
            @media(hover:hover){
            color: ${ props => props.invertColor ? WerfenColor : White };
                background-color: ${ SuggestionHoverColorActive };
                border-color: ${ SuggestionHoverColorActive };
                color: ${props => props.invertColor ? White : WerfenColor}
            }
        }
    }
    transition: all 300ms;
	
`;

const StyledSpan = styled.span`
    .fullText { 
        margin-right: 5px; 
        display: inline;
    }
`;

const DownloadRequestButton = (props) => {
    const { color, onClick, value, invertColor } = props;
    const [ text, setText ] = useState ( '' );
    const [ requestZipMutation, { loading, /*data, error*/ } ] = useMutation ( REQUEST_RESOURCES_ZIP_MUTATION );
    const request = props.request || [];
    const requestLength = request.length;
    const defaultMessage = `Select resources to download`;
    const loadingMessage = `Please wait...`;
    const errorMessage = `There was an error, please try again later...`
    const resource = requestLength === 1 ? 'resource' : 'resources'
    const downloadMessage = `Download ${ requestLength } selected ${ resource }`

    useEffect ( () => {
        if ( requestLength !== 0 ) {
            setText ( downloadMessage )
        } else {
            setText ( defaultMessage )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ requestLength ] );

    const requestZip = () => {
        // console.log({variables:{input:request}})
        requestZipMutation ( {
            variables: {
                input: request
            }
        } ).then ( () => {
            setText ( `Success! We will email you a link.` );
            setTimeout ( () => {
                props.resetDownloadRequest ();
                setText ( defaultMessage );
            }, 3000 );
        } )
            .catch ( error => {
                setText ( errorMessage )
                setTimeout ( () => {
                    setText ( downloadMessage )
                }, 3000 );
                console.error ( error )
            } );
    }

    return (
        <div>
            <StyledButton
                value={ value }
                color={ color }
                invertColor={ invertColor === true }
                onClick={ requestZip }
                disabled={ requestLength === 0 || loading }
                className={ ( requestLength !== 0 ? "active " : "" ) }
            >
                <StyledSpan>
                    <span className={ "fullText" }>{ loading ? loadingMessage : text }</span>
                </StyledSpan>
            </StyledButton>
            {
                requestLength > 0 &&
                <StyledButton
                    color={ color }
                    invertColor={ invertColor === true }
                    isIcon={ true }
                    onClick={ props.resetDownloadRequest }
                    title="Reset selection"
                    className="iconButton"
                >
                    <FeatherIconWrapper
                        color={ invertColor ? White : WerfenColor }
                        fillColor={ "none" }
                        width={ "20px" }
                        Icon={ CancelIcon }/>
                </StyledButton>
            }
        </div>
    )
};

export default DownloadRequestButton;